import { Component, EventEmitter, Input, OnChanges, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { IContextMenuOption } from '../../interfaces/context-menu-option.interface';
import type { ITreeNode } from '@circlon/angular-tree-component/lib/defs/api';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'claims-context-menu',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './context-menu-geography.html',
  styleUrl: './context-menu-geography.scss',
})
export class ContextMenuComponent<T extends IContextMenuOption> implements OnChanges  {
   @Input()
    public node!: ITreeNode;

    @Output()
    public readonly menuItemClicked: EventEmitter<T> = new EventEmitter<T>();

    public menuOptions: Array<T>= [];

    public ngOnChanges(changes: SimpleChanges): void {
        const simpleChange: SimpleChange = changes['node'];
        if (simpleChange.previousValue !== simpleChange.currentValue) {
            this.menuOptions = this.node?.data?.menuOptions;
        }
    }

    public onSelectMenuClick(menuOption: T): void {
        this.menuItemClicked.emit(menuOption);
    }
}
